
import { computed, defineComponent, onBeforeMount, PropType, ref } from "vue";

import EasyDrop from "@/components/EasyDrop.vue";
import EasyModal from "@/components/EasyModal.vue";
import EasyImageSlider from "@/components/EasyImageSlider.vue";
import { useStore } from "vuex";
import { SearchHotelRoom, SearchBookingOverview } from "@/types/models";
import { LocaleStrings, ValueIndexParams } from "@/types/paramModels";

export default defineComponent({
  components: {
    EasyDrop,
    EasyModal,
    EasyImageSlider
  },
  props: {
    bookingOverview: {
      type: Object as PropType<SearchBookingOverview>,
      required: true,
    },
    searchQuery: {
      type: Object,
      required: true,
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    },
    selectedRooms: {
      type: Array as PropType<Array<SearchHotelRoom>>,
      required: true
    },
  },
  emits: ["setPreviousViewRoute"],
  setup(_props, { emit }) {
    const store = useStore();

    const showModal = ref(false);
    const selectedRoom = ref<SearchHotelRoom>();

    const openModal = (event: Event, room: SearchHotelRoom) => {      
      event.preventDefault();
      selectedRoom.value = room;
      showModal.value = true;
    }
    const closeModal = () => {
      showModal.value = false;
    }

    const roomIndex = computed(() => store.getters["ApplicationModule/getAccommodationIndex"]);

    const query = computed(() => _props.searchQuery);

    const searchBookingOverview = computed(() => _props.bookingOverview);

    const updateRoom = (event: Event, room: SearchHotelRoom, index: number) => {
      const input = event.target as HTMLInputElement;
      if (input.checked && !room.isSelected) {
        const params = { value: room, index: index } as ValueIndexParams;
        store.dispatch("TravelSearchBookingModule/updateBookingRoom", params);
      } else {
        input.checked = true;
      }
    };

    const changeIndex = (add: boolean) => {
      if (add && roomIndex.value < searchBookingOverview.value.paxRooms.length - 1)
        store.dispatch("ApplicationModule/incrementAccommodationIndex");
      else if (!add && roomIndex.value > 0)
        store.dispatch("ApplicationModule/decrementAccommodationIndex");

      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    };
    onBeforeMount(() => {
      emit("setPreviousViewRoute", "hotel");
    });

    const adultSinglePlural = (count: number) => {
      return count > 1 ? _props.pageTexts['searchbarPersonPickerLabelAdults'] : _props.pageTexts['searchbarPersonPickerLabelAdult'];
    }

    const childSinglePlural = (count: number) => {
      return count > 1 ? _props.pageTexts['searchbarPersonPickerLabelChildren'] : _props.pageTexts['searchbarPersonPickerLabelChild'];
    }

    return {
      query,
      roomIndex,
      searchBookingOverview,
      updateRoom,
      changeIndex,
      adultSinglePlural,
      childSinglePlural,
      showModal,
      openModal,
      closeModal,
      selectedRoom
    };
  },
});
